import { render, staticRenderFns } from "./extension-records-table.vue?vue&type=template&id=45faaa63&scoped=true&"
import script from "./extension-records-table.vue?vue&type=script&lang=js&"
export * from "./extension-records-table.vue?vue&type=script&lang=js&"
import style0 from "./extension-records-table.vue?vue&type=style&index=0&id=45faaa63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45faaa63",
  null
  
)

export default component.exports